import React, { useEffect, useState } from 'react';
export function StickyBars() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 52);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 24 * 60 * 60;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    if (h > 0) {
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 w-full" style={{
    zIndex: 9999,
    contain: 'layout style'
  }} data-id="element-13">
      <div className="bg-brand-gold text-brand-black px-4 text-center flex items-center justify-center whitespace-nowrap overflow-hidden" style={{
      height: '32px',
      paddingTop: '4px',
      paddingBottom: '4px',
      fontSize: '11px',
      lineHeight: '1.2'
    }} data-id="element-14">
        <span className="font-bold" data-id="element-15">
          ⚡ OFERTA LIMITADA · {formatTime(timeLeft)} ⚡
        </span>
      </div>
    </div>;
}